import './reportsPage.scss';

import { format } from 'date-fns';
import * as React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { setLoading, setSuccess } from '../../../actions/loadingActions';
import { years, inspectionType } from '../../../constants/generals';
import { IHistory } from '../../../interfaces';
import { ChecklistModel } from '../../../model/ChecklistModel';
import { QuestionModel } from '../../../model/QuestionModel';
import { getMonthlyFormQuestions } from '../../../services/monthlyFormService';
import { getQuarterlyChecklistData } from '../../../services/quarterlyFormService';
import { Async } from '../../reusableComponents/Async';
import { BasePage } from '../../reusableComponents/BasePage';
import { ErrorPage } from '../../reusableComponents/ErrorPage';
import { Loader } from '../../reusableComponents/Loader';
import { SelectDropdown } from '../../reusableComponents/SelectDropdown';
import { prepareTable } from '../../../services/formService'; 
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export interface IQuarterlyChecklistReportProps {
    id: string;
    plantId: string;
    outfall: string;
    formType: string;
    history: IHistory;
    date: string;
    questions: QuestionModel[];
    checkListInstance: ChecklistModel;
}

export interface IQuarterlyChecklistReportState {
    date: Date;
    selectedYear: string;
    questions: {
        Question: string;
    }[];
}

export class QuarterlyChecklistReportImpl extends React.Component<IQuarterlyChecklistReportProps,
    IQuarterlyChecklistReportState> {
    constructor(props: IQuarterlyChecklistReportProps) {
        super(props);
        this.state = { selectedYear: new Date().getFullYear().toString(), date: new Date(props.date), questions: [], };
    }

    promise = async () => {
        const { formType, id, plantId, date, outfall, history: { push } } = this.props;
        await getQuarterlyChecklistData(id, format(date.replace(/\-/g, '/'), 'YYYY'), formType, outfall);
        const questions = await getMonthlyFormQuestions(this.props.formType);
        this.setState({ questions });
    }

    filterList = async (year) => {
        const { formType, id, plantId, outfall, history: { push } } = this.props;
        setLoading('DailyChecklistData');
        await getQuarterlyChecklistData(id, year, formType, outfall);
        this.setState({
            selectedYear: year
        });
        push(`/summary-reports/quarterly/${formType}/${plantId}/${year}/${id}/${outfall}`);
        setSuccess('DailyChecklistData');
    }

    renderAnswers = () => {
        if (!this.props.checkListInstance) {
            return <span />;
        }
        const { formType, checkListInstance: { props: { answers } } } = this.props; 
        const Tick = <i className="fa fa-check" aria-hidden="true"></i>;
        const Cross = <i className="fa fa-close"></i>;
        return <div className="answers" >
            {answers.map((data, index) => { 
                let month = answers[index]['month'];
                return <div
                    key={index + 99}
                    style={{ display: 'inline-block', width: `${100 / answers.length}%` }}
                    className="answer-row"
                >
                    {answers[index].data.map((answerData, index) => { 
                        if( (formType=='ShopInspection' ) && answerData.answer['quesNum'] =='28') {  //For omit time
                            return 
                        }
                        let answer = answerData.answer.answer;
                        if (answerData.answer['quesNum'] === '62') {
                            return <h4
                            key={index}
                            className="answer-column"
                        ><img style={{textAlign:'center'}} width="60%" src={answer} /></h4>;
                        } else {  
                            return <h4 className="answer-column" >
                                {answer?
                                <OverlayTrigger placement="top" overlay={  <Tooltip id={`Tooltip - ${answerData.answer['quesNum']} - ${month}`}>
                                        <span>{answerData.answer['quesNum']=='61' && answer ? format(answer, 'MM/DD/YYYY') : answer}</span>
                                    </Tooltip>}>
                                    <span style={{ opacity: 1, fontSize: '15px', cursor:'default' }} >{answer ? (answerData.answer['quesNum']=='61'? format(answer, 'MM/DD/YYYY') :
                                        (formType === 'QTRVisual' ? (answer.length > 86 ? answer.substring(0, 85) + "..." : answer) :
                                        answer === 'Yes' ? Tick : answer === 'No' ? Cross : (answer.length > 116 ? answer.substring(0, 115) + "..." : answer) ) ):
                                        <span>A</span>}
                                    < span > A</span></span>
                                </OverlayTrigger> :''}
                            </h4>
                            /* return <h4 style={{ opacity: 1, fontSize: '15px', cursor:'default' }} id={`Tooltip - ${answerData.answer['quesNum']} - ${month}`} key={index}
                                className="answer-column" title={answerData.answer['quesNum']=='61' && answer ? format(answer, 'MM/DD/YYYY') : answer}
                            >
                                {answer ? (answerData.answer['quesNum']=='61'? format(answer, 'MM/DD/YYYY') :
                                    (formType === 'QTRVisual' ? (answer.length > 86 ? answer.substring(0, 85) + "..." : answer) :
                                    answer === 'Yes' ? Tick : answer === 'No' ? Cross : (answer.length > 116 ? answer.substring(0, 115) + "..." : answer) ) ):
                                    <span>A</span>}
                                < span > A</span>
                            </h4>; */
                        }
                    })}
                </div>;
            })}
        </div>;
    }

    renderDates = () => {
        const answers = ['First Quarter', 'Second Quarter', 'Third Quarter', 'Fourth Quarter'];
        return <div className="dates" >
            {answers.map((que, index) => {
                return <h4 key={index + 999} style={{ width: `${100 / answers.length}%` }}  >
                    {que}
                </h4>;
            })}
        </div>;
    }

    renderQuestions = () => {
        const questions = this.props.questions;
        return <div className="questions" >
            {questions.map((que, index) => {
                return <h4 key={index + 88}  >{que.props.question.length > 120 ? que.props.question.substring(0, 119) + "..." : que.props.question}</h4>;
            })}
        </div>;
    }

    renderContent = () => {
        if (!this.props.checkListInstance) {
            return <span />;
        }
        const { checkListInstance: { props: { answers } } } = this.props;
        return <div>
            <div className="chart-title" id="chartTitle" >
                <SelectDropdown
                    onChange={this.filterList}
                    menuItems={years()}
                    defaultValue={format(this.props.date, 'YYYY')}
                />
                {/* <button className="download-button">Download As PDF</button> */}
            </div>
            <Async
                identifier="DailyChecklistData"
                promise={() => setSuccess('DailyChecklistData')}
                loader={<Loader type="async" />}
                content={
                    <div style={{ display: 'flex' }} >
                        <div className="dates-row" >{this.renderDates()}</div>
                        <PerfectScrollbar>
                            <div id="container" style={{ height: '84vh' }} >
                                <div className="questions-column" >{this.renderQuestions()}</div>
                                <div className="answers-data" >{this.renderAnswers()}</div>
                            </div>
                        </PerfectScrollbar>
                    </div>
                }
                error={<ErrorPage />}
            />
        </div>;
    }

    handlePrint = () => {
        const { checkListInstance } = this.props; 
        const queryString = !isNaN(Number(this.props.outfall)) 
        ? `${inspectionType(this.props.formType)} Reports for Plant ${this.props.plantId} and Outfall ${this.props.outfall}
         (${format(this.props.date, 'YYYY')})` : 
            `${this.props.formType} Reports for Plant ${this.props.plantId} (${format(this.props.date,
                'YYYY')})`;
        prepareTable(checkListInstance,
            this.state.questions.reverse(),
            queryString,
            100, 'Quarter');
    }

    render() {
        return <BasePage
            className="daily-checklist"
            pageTitle={`${inspectionType(this.props.formType )} Reports for 
             ${format(this.props.date.replace(/\-/g, '/'), 'YYYY')} for Plant ${this.props.plantId}`}
            sideButton={
                <div key="details" onClick={this.handlePrint} className="button" id="print-button" style={{
                    position: 'absolute',
                    right: '10px',
                    width: 'fit-content',
                    paddingRight: '10px'
                }} >
                    <i className="fa fa-print" aria-hidden="true"></i>
                    &nbsp;
                    <span> Print</span>
                </div>
            }
        >
            <Async
                identifier="QuarterlyChecklistReport"
                promise={this.promise}
                loader={<Loader type="async" />}
                content={this.renderContent()}
                error={<ErrorPage />}
            />
        </BasePage>;
    }
}

export function mapStateToProps(state, ownProps) {
    const id = ownProps.match.params.id;
    const formType = ownProps.match.params.formType;
    const outfall = ownProps.match.params.outfall;
    const checkListInstance = ChecklistModel.getBy('type', formType);
    const questions = QuestionModel.getAllByType(formType);
    return {
        checkListInstance,
        id: ownProps.match.params.id,
        plantId: ownProps.match.params.plantId,
        date: ownProps.match.params.date,
        formType, outfall,
        questions
    };
}

export const QuarterlyChecklistReport =
    withRouter(connect<{}, {}, IQuarterlyChecklistReportProps>(mapStateToProps)(QuarterlyChecklistReportImpl as any));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Summary/ReportsPage/QuarterlyChecklistReport.tsx